<template>
  <v-app>
    <div
      v-if="loading"
    >
      <v-progress-linear
        v-if="!welif&&!uid"
        indeterminate
        color="green"
      />
      <transition appear>
        <p class="text-h4 text-center welcome" v-if="welif">Welcome</p>
      </transition>
      <v-btn v-if="showResetButton" class="btn btn-primary ma-5" @click="deleteAllIndexedDB()">もしも読み込みが終わらない場合、こちらをクリックしてリセットしてください。</v-btn>
    </div>
    <router-view v-else/>
  </v-app>
</template>

<script>
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
export default {
  name: 'App',
  data(){
    return{
      welif: true,
      showResetButton: false,
    }
  },
  created: async function() {
    this.$store.dispatch('auth/initAuth');
  },
  mounted(){
    this.wel()
        
    // queryパラメーターでchannelを取得し、localStorageに保存する
    const channel = this.$route.query.channel;
    if (channel) {
      localStorage.setItem('channel', channel);
    }
    const initiationKey = this.$route.query.initiationKey;
    if (initiationKey) {
      localStorage.setItem('initiationKey', initiationKey);
    }
    const options = this.$route.query.options;
    if (options) {
      options.split(',').forEach((option) => {
        localStorage.setItem(option, true);
      });
    }
  },
  computed: {
    uid() {
      return this.$store.state.auth?.user?.uid || '';
    },
    isAuthed() {
      return this.$store.state.auth?.isAuthed;
    },
    loading() {
      return (
        this.welif
      ||
        !this.uid
      ||
        !(this.$store.state.memLoaded&&this.$store.state.lidLoaded)
      ||
        (this.$store.state.lid==null||this.$store.state.alid==null||this.$store.state.navlid==null||this.$store.state.members==null)
      )
    }
  },
  methods: {
    wel: function(){
      setTimeout(() => {
        this.welif = false
      }, 1000)
      setTimeout(() => {
        this.showResetButton = true
      }, 7000)
    },
    deleteAllIndexedDB() {
      console.error("deleteAllIndexedDB process start")
      // 全てのdbをlistする
      window.indexedDB.databases().then((dbs) => {
        // 全てのdbを削除する
        dbs.forEach((db) => {
          console.error("deleteAllIndexedDB process delete", db.name)
          window.indexedDB.deleteDatabase(db.name);
        });
      }).finally(() => {
        console.error("deleteAllIndexedDB process end")
        location.reload()
      });
    }
  },
}
</script>

<style scoped>
@import "~leaflet.markercluster/dist/MarkerCluster.css";
@import "~leaflet.markercluster/dist/MarkerCluster.Default.css";
.border {
  border: 2px dashed orange;
}
::v-deep .v-application--wrap {
  min-height: fit-content;
}
.v-enter-active, .v-leave-active {
  transition: opacity 1s;
}

.v-enter{
  opacity: 0;
}
.v-enter-to{
    opacity: 1;
}
.v-leave {
    opacity: 1;
}
.v-leave-to {
    opacity: 0;
}
.welcome{
    margin-top: 20%;
}
*{
  font-family:mplus-2c-medium;
}
</style>
<style>
.firebase-emulator-warning {
  display: none;
}
*{
  font-family:mplus-2c-medium;
}
</style>
